import Attrs from '../models/Attrs'
import type { Component } from '../models/types'
import replaceStorageURLsFromFirebaseToCloudflare from '../helpers/replaceStorageURLsFromFirebaseToCloudflare'
import renderTemplate from '../helpers/templating'
import { addLanguageController } from '../helpers/utils'

const CONTROLLER = 'components--custom-html'
export default function renderCustomHTML(
  component: Component,
  attrs: Attrs,
  userData: { [key: string]: unknown }
): string {
  attrs
    .addController(CONTROLLER)
    .addAction(`${CONTROLLER}:update->flow#batchUpdate`, `${CONTROLLER}:info-box->flow#openInfoBox`)

  //* Add template controller if the text has {{
  if (component.text && component.text.includes('{{'))
    attrs
      .addController('template')
      .addValueIfExists('template', 'text', encodeURIComponent(component.text || ''))
      .addValueIfExists('template', 'always-rerender', component.always_rerender)

  //* Add language controller for the text
  addLanguageController({ attrs, component, keys: ['text'] })

  const textAttrs = new Attrs(attrs.static_render)

  const textBeforeTemplate = replaceStorageURLsFromFirebaseToCloudflare(component.text)

  const text = renderTemplate(textBeforeTemplate, userData)
  return `<div ${attrs}><div ${textAttrs}>${text}</div></div>`
}
